module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/355.a6a9d15a.png";